import { IOptionProps } from "@blueprintjs/core";
import { getIn } from "formik";
import {
  FGCustomPanel,
  FGSelectInput,
  FGTextInput,
  FieldGroup,
} from "nsitools-react";
import * as React from "react";

import { ERequestState } from "../../../../api";
import { FGSRSHDateMaskInput } from "../../../../components";
import { useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";

export interface IDrupalKennelNameChangeRequestFormProps {
  kennelNameChangeRequestId: number;
  initialdata: any;
  loading: boolean;
}

export const DrupalKennelNameChangeRequestForm: React.FunctionComponent<IDrupalKennelNameChangeRequestFormProps> = ({
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const [kennelTypes, ktloading] = useReferential(
    (a) => a.getKennelTypes(),
    false,
    []
  );
  const [openedKennels, okloading] = useReferential(
    (a) => !loading && a.getOpenedKennels(initialdata?.kennelId),
    true,
    [loading]
  );

  const generateNameOfferList = React.useCallback((formik) => {
    const names = [];
    for (let index = 1; index < 6; index++) {
      const element = getIn(formik?.values, `nameOffer${index}`);
      if (element) {
        names.push(element);
      }
    }
    return names?.map((p) => {
      return { value: p, label: p };
    }) as IOptionProps[];
  }, []);

  return (
    <DrupalFormGenerator
      initialValues={initialdata}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      saving={false}
      deleting={false}
      hideButtons
    >
      <FieldGroup
        columns={2}
        fieldsetProps={{ divider: false, title: t(ETLCodes.RequestData) }}
      >
        <div>
          <FGSRSHDateMaskInput
            name="request.requestDate"
            label={t(ETLCodes.RequestDate)}
          />
          {initialdata?.request?.status === ERequestState.EXECUTED && (
            <FieldGroup columns={2}>
              <FGSRSHDateMaskInput
                name="request.executionDate"
                label={t(ETLCodes.ClosingDate)}
              />
            </FieldGroup>
          )}
          <FGSelectInput
            name="kennelId"
            label={t(ETLCodes.Kennel)}
            items={openedKennels}
            loading={okloading}
          />
        </div>
      </FieldGroup>
      <DrupalFieldSet title={t(ETLCodes.FileAffix)}>
        <FieldGroup columns={2}>
          <FGTextInput
            name="nameOffer1"
            label={t(ETLCodes.NameOffer1)}
            maxLength={29}
            forceCase={"upper"}
          />
          <FGSelectInput
            name="nameOffer1Type"
            label={t(ETLCodes.Affix)}
            items={kennelTypes}
            loading={ktloading}
          />
        </FieldGroup>
      </DrupalFieldSet>
      {(initialdata?.request?.status === ERequestState.TO_EVALUATE_FCI ||
        initialdata?.request?.status === ERequestState.EXECUTED) && (
        <DrupalFieldSet title={t(ETLCodes.FCIDecision)}>
          <FGCustomPanel>
            {(ctx) => {
              return (
                <FGSelectInput
                  name="finalName"
                  label={t(ETLCodes.FinalName)}
                  items={generateNameOfferList(ctx.formik)}
                  loading={ktloading}
                />
              );
            }}
          </FGCustomPanel>
          <FGTextInput name="fciNumber" label={t(ETLCodes.FciNumber)} />
        </DrupalFieldSet>
      )}
      <DrupalStepperButtonBloc backOnly />
    </DrupalFormGenerator>
  );
};
